import { useEffect, useMemo } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { useToast } from "@/components/base/Toast";
import { getFeaturedTitles, titles } from "@/mocks/titles";
import { getNewsHighlights } from "@/mocks/news";
import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryEntries from "@/pages/home/components/CategoryEntries";
import LatestRecommend from "@/pages/home/components/LatestRecommend";
import NewsHighlights from "@/pages/home/components/NewsHighlights";
import BrandIntro from "@/pages/home/components/BrandIntro";

const HOME_TDK = {
  title: "星光传媒电影电视剧推荐与影视资讯",
  description:
    "星光传媒官网提供丰富的影视作品介绍及最新影视资讯，覆盖电影、电视剧等多类别内容，助您了解星光传媒旗下优质影视资源。",
  keywords: "星光传媒,影视作品,电影推荐,电视剧介绍,影视资讯,星光传媒影视",
};

export default function Home() {
  useSeo({
    title: HOME_TDK.title,
    description: HOME_TDK.description,
    keywords: HOME_TDK.keywords,
    canonicalPath: "/",
  });

  const { notify } = useToast();
  const featured = useMemo(() => getFeaturedTitles(), []);
  const highlights = useMemo(() => getNewsHighlights(), []);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      notify("本站为演示站点，影视作品与资讯均为虚构示例数据");
    }, 1200);
    return () => window.clearTimeout(timer);
  }, [notify]);

  const stats = useMemo(
    () => [
      { value: `${titles.length}`, label: "部在荐作品" },
      { value: `${titles.filter((item) => item.type === "movie").length}`, label: "部电影" },
      { value: `${titles.filter((item) => item.type === "tv").length}`, label: "部剧集" },
      { value: "2026", label: "年度片单更新中" },
    ],
    [],
  );

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar variant="overlay" currentLabel="首页" />
      <main>
        <HeroCarousel items={featured} />

        <section className="px-4 md:px-6 border-b border-background-200 bg-background-50">
          <div className="max-w-[1440px] mx-auto grid grid-cols-2 md:grid-cols-4">
            {stats.map((stat, index) => (
              <div
                key={stat.label}
                className={`py-5 md:py-7 ${index % 2 !== 0 ? "pl-4 md:pl-6" : "pr-4 md:pr-6"} ${
                  index !== 0 ? "md:border-l md:border-background-200" : ""
                }`}
              >
                <p className="font-heading text-xl md:text-3xl font-semibold text-primary-800 leading-none">{stat.value}</p>
                <p className="text-xs md:text-sm text-foreground-600 mt-2">{stat.label}</p>
              </div>
            ))}
          </div>
        </section>

        <CategoryEntries />
        <LatestRecommend />
        <NewsHighlights items={highlights} />
        <BrandIntro />
      </main>
      <Footer />
    </div>
  );
}